import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Services from './services';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

class CikkProfilContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true,
      value: null,
      saveButtonLoading: false,
    };
  }

  // componentDidMount() {
  //  this.updateValue();
  // }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateValue();
      }
    }
  }

  onSubmit = (e, submitObj) => {
    submitObj.azonosito = 'CIKK_RAKTARON_KIVUL';
    submitObj.tipus = 'BOOLEAN';
    submitObj.ertek = submitObj.kivul;
    submitObj.technikai = false;
    submitObj.nev = 'CIKK_RAKTARON_KIVUL';
    
    this.setState({ saveButtonLoading: true });

    Services.updateCikkProfil(submitObj, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Cikk profil rögzítve!');
        this.toggleDisable();
        this.setState({ saveButtonLoading: false });
      }
    });
  }

  updateValue = () => {
    Services.getCikkProfil((err, res) => {
      if (!err) {
        this.setState({
          value: res[0].toString()
        });
      }
    });
  }

  toggleDisable = () => {
    this.setState({
      disabled: !this.state.disabled
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-3">
          <RFForm onSubmit={this.onSubmit}>
            <RFField
              type="select"
              name="kivul"
              label="Kezel raktáron kívüli cikket? *"
              disabled={this.state.disabled}
              value={this.state.value}
              required
              defaultSelect={<option value="" disabled>Válassz értéket...</option>}
              selectOptions={(
                <>
                  <option value="false">
                    Nem
                  </option>
                  <option value="true">
                    Igen
                  </option>
                </>
              )}
            />
            {this.props.globals.hasRole(['CIKK_PROFIL'], true) && (
              <> 
                <ProgressButton type="submit" disabled={this.state.disabled} color="primary" loading={this.state.saveButtonLoading}>
                  Mentés
                </ProgressButton>
                {' '}
                <Button onClick={this.toggleDisable} disabled={!this.state.disabled} type="button" color="success">
                  Módosítás
                </Button>
                {' '}
              </>
            )}
          </RFForm>
        </div>
      </div>
    );
  }
}

CikkProfilContent.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool
};

export default CikkProfilContent;
